export const CHART_COLORS = {
	primary: 'hsl(var(--chart-1))',
	secondary: 'hsl(var(--chart-2))',
	tertiary: 'hsl(var(--chart-3))',
	quaternary: 'hsl(var(--chart-4))',
	quinary: 'hsl(var(--chart-5))',
} as const;

// Default color palette for pie chart slices
export const DEFAULT_PIE_COLORS = [
	CHART_COLORS.primary,
	CHART_COLORS.secondary,
	CHART_COLORS.tertiary,
	CHART_COLORS.quaternary,
	CHART_COLORS.quinary,
	'hsl(142 76% 36%)', // green
	'hsl(47 96% 53%)', // yellow
	'hsl(280 87% 65%)', // purple
];
